import { TextField, TextFieldProps } from '@lessonup/ui-components';
import React, { forwardRef } from 'react';
import { useEditorInputKeybindController } from './hooks/useEditorInputKeybindController';

export const EditorTextField = forwardRef<HTMLInputElement, TextFieldProps>(
  function EditorTextField(props, forwardedRef) {
    const { onBlur, onFocus } = useEditorInputKeybindController();

    return <TextField onBlur={onBlur} onFocus={onFocus} size={props.size || 'medium'} {...props} ref={forwardedRef} />;
  }
);
